import styled from '@emotion/styled'

import Input from './component'

export default styled(Input)``
